var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSideIconTeams = function SvgSideIconTeams(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64021 1.3042C5.06977 1.3042 3.79297 2.54954 3.79297 4.07417V4.08259C3.80134 5.10764 4.03577 6.24885 4.50284 7.15953C4.96153 8.07202 5.68814 8.78227 6.64021 8.78227C7.59228 8.78227 8.31889 8.07202 8.77758 7.15953C9.24465 6.24704 9.47788 5.10764 9.49582 4.08259V4.07417C9.49582 2.54954 8.21065 1.3042 6.64021 1.3042Z",
    fill: "white",
    stroke: "#82C8B8",
    strokeWidth: 0.876163
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4371 3.80908C13.4957 3.80908 14.358 4.64152 14.358 5.67679C14.3401 6.46469 14.1421 7.37718 13.8019 8.06154C13.4508 8.73688 12.9933 9.16664 12.4371 9.16664C11.8798 9.16664 11.4127 8.73688 11.0724 8.06154C10.7214 7.37718 10.5336 6.46469 10.5234 5.67679C10.5234 4.64152 11.378 3.80908 12.4371 3.80908Z",
    fill: "white",
    stroke: "#82C8B8",
    strokeWidth: 0.876163
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8958 5.25195C17.736 5.25195 18.4204 5.9275 18.4204 6.76766C18.4062 7.40706 18.2491 8.14757 17.979 8.70296C17.7004 9.25102 17.3373 9.59978 16.8958 9.59978C16.4535 9.59978 16.0828 9.25102 15.8127 8.70296C15.5341 8.14757 15.385 7.40706 15.377 6.76766C15.377 5.9275 16.0552 5.25195 16.8958 5.25195Z",
    fill: "white",
    stroke: "#82C8B8",
    strokeWidth: 0.876163
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64006 9.67871C9.73847 9.67871 12.2783 12.5028 12.2783 16.0366C12.2783 16.3875 12.2418 16.7288 12.197 17.0617C10.7157 18.0265 8.77743 18.632 6.64006 18.632C4.50269 18.632 2.56266 18.0265 1.08193 17.0533C1.03648 16.7204 1 16.3875 1 16.0366C1 12.5028 3.54164 9.67871 6.64006 9.67871Z",
    fill: "white",
    stroke: "#82C8B8",
    strokeWidth: 0.876163
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.437 9.97705C14.9966 9.97705 17.1059 12.31 17.1059 15.2461C17.1059 15.535 17.0796 15.8083 17.0425 16.0786C15.8027 16.8851 14.2054 17.3847 12.437 17.3847C12.3652 17.3847 12.2833 17.3769 12.2122 17.3769L12.2391 17.3504L12.257 17.2541C12.3204 16.8592 12.3467 16.4475 12.3467 16.0352C12.3467 13.8949 11.4658 11.9669 10.0664 10.7036C10.7661 10.2395 11.5752 9.97705 12.437 9.97705Z",
    fill: "white",
    stroke: "#82C8B8",
    strokeWidth: 0.876163
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2804 10.4697C19.3355 10.4697 21.0291 12.3868 21.0291 14.7994C21.0291 15.0368 21.008 15.2613 20.9782 15.4834C19.9828 16.1462 18.7003 16.5567 17.2804 16.5567C17.2228 16.5567 17.157 16.5503 17.0998 16.5503L17.1214 16.5285L17.1358 16.4494C17.1867 16.1249 17.2079 15.7866 17.2079 15.4478C17.2079 13.689 16.5006 12.1049 15.377 11.0667C15.9388 10.6854 16.5884 10.4697 17.2804 10.4697Z",
    fill: "white",
    stroke: "#82C8B8",
    strokeWidth: 0.876163
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSideIconTeams);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/side-icon-Teams.947c0e3476f7c32bbf797db42533edee.svg";